import * as httpService from './httpService';
import { withEnterpriseId } from 'spark-state/stateUtil';

const enterpriseURL = `${process.env.SPARK_DOMAIN}/enterprise`;
const enterpriseUserURL = `${process.env.SPARK_DOMAIN}/enterprise/user`;

/*
 * getEnterpriseList function fetch the list if enterprises from Service API.
 */
export const getEnterpriseList = httpService.getCollection(`${enterpriseURL}/grid`, {
    defaults: { sort: 'entTitle,desc' }
});

/*
 * getEnterpriseCtmsRefreshDate is for ctmsRefresh.
 * @param {number} [entId=1]
 */
export const getEnterpriseCtmsRefreshDate = withEnterpriseId(entId =>
    httpService.get(`${enterpriseURL}/ctmsRefresh/${entId}`)
);

/**
 * getUsersForEnterprise fetch list of user for the selected enterprise.
 * @param {*} enterpriseId
 */
export const getUsersForEnterprise = enterpriseId =>
    httpService.getCollection(`${enterpriseURL}/user/${enterpriseId}`);

/**
 * createEnterprise function hepls to create new enterprise.
 * It will post the enterprise information to the service.
 * @param {*} enterprise
 */
export const createEnterprise = enterprise => httpService.create(enterpriseURL, enterprise);

/**
 * updateEnterprise function hepls to update the enterprise.
 * It will send updated information to the service.
 * @param {*} enterpriseId
 * @param {*} [{ entDesc, entTitle }={}]
 */
export const updateEnterprise = (enterpriseId, { entDesc, entTitle, domain } = {}) =>
    httpService.update(`${enterpriseURL}/${enterpriseId}`, { entDesc, entTitle, domain });

/**
 * addEnterpriseUser hepls to add new user to the enterprise.
 * @param {*} enterpriseId
 * @param {*} user
 * @returns
 */
export const addEnterpriseUser = (enterpriseId, user) => {
    user = { ...user, enterpriseId, reportType: user.reportTypeId };
    //return httpService.create(enterpriseUserURL, JSON.stringify(user));
    return httpService.create(`${enterpriseUserURL}/${enterpriseId}`, JSON.stringify(user));
};
/**
 * updateUserEmail hepls to update email id of an user.
 * @param {*} enterpriseId
 * @param {*} oldEmail is old email id of the user
 * @param {*} newEmail is new email id of the user
 */
export const updateUserEmail = (enterpriseId, oldEmail, newEmail) => {
    let formData = {
        'oldEmail': oldEmail,
        'newEmail': newEmail
    };
    return httpService.create(`${enterpriseURL}/userEmailUpdate/${enterpriseId}`, JSON.stringify(formData));
}
/**
 * deleteEnterpriseUser fnction hepls to delete the user.
 * @param {*} enterpriseId
 * @param {*} userId
 */
export const deleteEnterpriseUser = (enterpriseId, userId) =>
    httpService.remove(`${enterpriseURL}/user/${enterpriseId}/${userId}`);
